<div class="canvas-container">
  <canvas
    #canvas
    width="400"
    height="100"
    (mousedown)="startDrawing($event)"
    (mouseup)="stopDrawing()"
    (mouseleave)="stopDrawing()"
    (mousemove)="draw($event)"
    (touchstart)="startDrawing($event)"
    (touchend)="stopDrawing()"
    (touchmove)="draw($event)"
  ></canvas>
</div>

<div class="button-row">
  <ion-button (click)="saveAsBase64()">Speichern</ion-button>
  <ion-button (click)="clearCanvas()">Leeren</ion-button>
</div>
